module.exports = __webpack_public_path__ + "img/izibiz-logo.ddd7503c.png";